export default __webpack_public_path__ + "9b20f04817965fd7bd6565fdf6c3d757.svg";